<div class="-docheader-sec-nav -container">
  <ul>
    @for (navigationItem of navigationTabs; track navigationItem) {
    <li [ngClass]="{ 'is-active': getActiveClass(navigationItem) || navigationItem.active }">
      <app-link [to]="navigationItem.path">
        {{ navigationItem.title }}
      </app-link>
    </li>
    }
  </ul>
  <div class="-container-right">
    <releasenotes-subscription *ngIf="canSubscribe"></releasenotes-subscription>
    @if (metadataObj.template === 'redoc' || metadataObj.template === 'sdk') {
      <div class="d-flex justify-content-end">
        @if (!metadataObj['hide-api-key']) {
          <wpbutton mode="getapikey" class="-secondary">{{ metadataObj['api-key-text'] ? metadataObj['api-key-text'] : 'Get API Key' }}</wpbutton>
        }
        <api-versions-convergence></api-versions-convergence>
      </div>
    }
    <!-- <div *ngIf="metadataObj.template === 'sdk'" class="d-flex justify-content-end">
    <api-versions-convergence></api-versions-convergence>
  </div> -->
  </div>
</div>
